import {
  GatewayImportExportAssujetti,
  GatewayInfoSocieteOrias,
} from "@conformite/gateway";
import { isIas, isIobsp, isMulti } from "@endya-conformite/ui-kit";
import { EntreprisesBySiren } from "@src/store/store.definition";
import { concat } from "lodash";
import { excelLabelByAssujettiRole } from "../ImportExport.definition";
import { RegistreFormationExcelMappedTemplate } from "../RegistreExcelTemplate";

function transformAssujetti(
  assujetti: GatewayImportExportAssujetti.AssujettiRowImportAssujetti
): RegistreFormationExcelMappedTemplate["assujetti"] {
  return {
    name: assujetti.name,
    formation: excelLabelByAssujettiRole[assujetti.role],
    surname: assujetti.surname,
  };
}

function transformActivite(
  categories: GatewayImportExportAssujetti.ExportRegistreRowResponse["categories"]
): RegistreFormationExcelMappedTemplate["activite"] {
  let typeEntreprise = "";
  if (isMulti(categories)) {
    typeEntreprise = "IAS et IOBSP";
  } else if (isIas(categories)) {
    typeEntreprise = "IAS";
  } else if (isIobsp(categories)) {
    typeEntreprise = "IOBSP";
  } else {
    typeEntreprise = "";
  }

  return { activite: typeEntreprise };
}

function transformFormation(
  formation: GatewayImportExportAssujetti.AssujettiRowFormation,
  verificationDate: Date | null
): RegistreFormationExcelMappedTemplate["formation"] {
  return {
    theme: formation.theme,
    hours: formation.nombreHeures,
    verificationDate,
  };
}

const KEYS_HEURES_FORMATION_IOBSP = [
  "heuresFormationCreditConsommation",
  "heuresFormationCreditImmobilier",
  "heuresFormationCreditPretViagerHypotecaire",
  "heuresFormationCreditRegroupementCredits",
  "heuresFormationCreditServicePaiement",
] as const;
const labelByKeysHeuresFormationIOBSP: Record<
  (typeof KEYS_HEURES_FORMATION_IOBSP)[number],
  string
> = {
  heuresFormationCreditConsommation: "Crédit à la consommation",
  heuresFormationCreditImmobilier: "Crédit immobilier",
  heuresFormationCreditPretViagerHypotecaire: "Prêt viager hypothécaire",
  heuresFormationCreditRegroupementCredits: "Regroupement de crédits",
  heuresFormationCreditServicePaiement: "Service de paiement",
};
const sousCategorieIOBSPByKey: Record<
  (typeof KEYS_HEURES_FORMATION_IOBSP)[number],
  GatewayInfoSocieteOrias.ActiviteBancaire
> = {
  heuresFormationCreditConsommation:
    GatewayInfoSocieteOrias.ActiviteBancaire.CREDIT_CONSOMMATION,
  heuresFormationCreditImmobilier:
    GatewayInfoSocieteOrias.ActiviteBancaire.CREDIT_IMMOBILIER,
  heuresFormationCreditPretViagerHypotecaire:
    GatewayInfoSocieteOrias.ActiviteBancaire.PRET_VIAGER_HYPOTECAIRE,
  heuresFormationCreditRegroupementCredits:
    GatewayInfoSocieteOrias.ActiviteBancaire.REGROUPEMENT_CREDITS,
  heuresFormationCreditServicePaiement:
    GatewayInfoSocieteOrias.ActiviteBancaire.SERVICE_PAIEMENT,
};
export function transformAPIRowsForToRows(
  mapping: GatewayImportExportAssujetti.ExportRegistreRowResponse,
  entreprisesBySiren: EntreprisesBySiren
): RegistreFormationExcelMappedTemplate[] {
  const baseAssujetti = transformAssujetti(mapping.assujetti);
  const rows: RegistreFormationExcelMappedTemplate[] = [];
  const { formationContinueIAS, formationContinueIOBSP, categories } = mapping;
  const entreprise = entreprisesBySiren[mapping.assujetti.sirenCompany];

  if (isIas(categories) && formationContinueIAS?.formations.length) {
    formationContinueIAS.formations.forEach((formation) => {
      if (!formation.theme && !formation.nombreHeures) return;
      rows.push({
        assujetti: baseAssujetti,
        activite: transformActivite(categories),
        formation: transformFormation(
          formation,
          formationContinueIAS.dateDernierVerification
        ),
      });
    });
  }
  KEYS_HEURES_FORMATION_IOBSP.forEach((key) => {
    if (
      concat(
        entreprise.sousCategorieCOBSP,
        entreprise.sousCategoriesIOBSP
      ).includes(sousCategorieIOBSPByKey[key]) &&
      formationContinueIOBSP[key] &&
      formationContinueIOBSP[key] > 0
    ) {
      rows.push({
        assujetti: baseAssujetti,
        activite: transformActivite(categories),
        formation: {
          theme: labelByKeysHeuresFormationIOBSP[key],
          hours: formationContinueIOBSP[key],
          verificationDate: formationContinueIOBSP.dateDernierVerification,
        },
      });
    }
  });

  if (isIobsp(categories) && formationContinueIOBSP?.formations.length) {
    formationContinueIOBSP.formations.forEach((formation) => {
      if (!formation.theme && !formation.nombreHeures) return;
      rows.push({
        assujetti: baseAssujetti,
        activite: transformActivite(categories),
        formation: transformFormation(
          formation,
          formationContinueIOBSP.dateDernierVerification
        ),
      });
    });
  }

  return rows;
}
